import randomColorFunction from 'randomcolor';

export const randomColor = randomColorFunction;
